export default __webpack_public_path__ + "static/media/gif4.50bdc7f9.gif";